import React from "react";
import Input from "../../../../../../../components/Input";
import useEletronicInventoryStore from "../../store/useStore";

export default function RowOneAndTwo() {
  const { defaultValues } = useEletronicInventoryStore();
  const { saveDataOfField } = useEletronicInventoryStore();

  return (
    <>
      <div className="box-row">
        <Input
          name="nameProduct"
          label="Nome do Produto"
          placeholder="Digite o nome do produto"
          value={defaultValues?.nameProduct}
          setValue={(event) => saveDataOfField(event.target)}
        />
        <Input
          name="assetNumber"
          label="Número do Patrimônio"
          placeholder="Digite o número do Patrimônio"
          value={defaultValues?.assetNumber}
          setValue={(event) => saveDataOfField(event.target)}
        />
      </div>
      <div className="box-row">
        <Input
          name="serialNumber"
          label="Número de Série"
          placeholder="Digite o número de série"
          value={defaultValues?.serialNumber}
          setValue={(event) => saveDataOfField(event.target)}
        />
        <Input
          name="screen"
          label="Tela"
          placeholder="Digite o tamanho de tela"
          value={defaultValues?.screen}
          setValue={(event) => saveDataOfField(event.target)}
        />
      </div>
    </>
  );
}
